/* himedi-lb-about.js: scroll reveal for the About sections (ported from the draft's <script id="draft-js">). Loaded by the about-model section. */
(function () {
  "use strict";
  /* Scroll reveal (MOTION.md rule 6): once, top past 85% of the viewport, siblings entering together stagger 60ms. */
  (function () {
    var els = Array.prototype.slice.call(document.querySelectorAll([".story-left",".story-copy",".vet .cols > *",".vet .pillar",".vet .vetcta",".gap-copy",".gaprows",".model .wrap > .eyebrow",".model .wrap > h2",".mcard"].join(",")));
    if (!els.length || !("IntersectionObserver" in window)) return;
    document.documentElement.classList.add("d-rv-on");
    els.forEach(function (e) { e.classList.add("d-rv"); });
    var io = new IntersectionObserver(function (entries) {
      var n = new Map();
      entries.forEach(function (en) {
        if (!(en.isIntersecting || en.boundingClientRect.top < 0)) return;
        var t = en.target, p = t.parentElement, k = n.get(p) || 0;
        n.set(p, k + 1);
        t.style.setProperty("--rv-d", Math.min(k, 4) * 60 + "ms");
        t.classList.add("d-in");
        io.unobserve(t);
        setTimeout(function () { t.classList.add("d-done"); }, 700 + Math.min(k, 4) * 60);
      });
    }, { rootMargin: "0px 0px -15% 0px", threshold: 0 });
    els.forEach(function (e) { io.observe(e); });
  })();
})();
